import { render } from "./indexFooterlight.vue?vue&type=template&id=8a118e08"
import script from "./indexFooterlight.vue?vue&type=script&lang=js"
export * from "./indexFooterlight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__